module.exports = __webpack_public_path__ + "static/media/cq_nuovo_messaggio b.b8120c85.svg";